import SpinButton from './SpinButton'
import './SpinButton.css'

export default SpinButton



// WEBPACK FOOTER //
// ./src/components/SpinButton/index.js